/**
 * Zustand store for authentication state (global, not widget-scoped)
 */

import type { UserSession } from '@refinevoice/shared';
import { create } from 'zustand';

interface ErrorNotification {
  title: string;
  message: string;
  type: 'error' | 'warning' | 'info';
}

interface AuthStore {
  // User session
  userSession: UserSession | null;

  // Error notifications
  errorNotification: ErrorNotification | null;

  // Actions
  setUserSession: (session: UserSession | null) => void;
  showError: (title: string, message: string, type?: 'error' | 'warning' | 'info') => void;
  clearError: () => void;
}

export const useAuthStore = create<AuthStore>((set) => ({
  // Initial state
  userSession: null,
  errorNotification: null,

  // Actions
  setUserSession: (session) => set({ userSession: session }),

  showError: (title, message, type = 'error') =>
    set({
      errorNotification: { title, message, type },
    }),

  clearError: () => set({ errorNotification: null }),
}));
